module.exports = __webpack_public_path__ + "img/xlkc_cjwt.60f6dbea.png";